/**
 * Product Card Quick Add Modal Functionality
 * Abre un modal para añadir productos al carrito desde las tarjetas de producto
 * Utiliza el componente ProductVariantSelector para manejar variantes
 */

// Instancia global del selector de variantes
let variantSelector = null;
let currentModal = null;
let scrollPosition = 0;

document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('ProductQuickAddModal');
  if (!modal) {
    return;
  }

  currentModal = modal;

  // NO inicializar el selector de variantes aquí - se inicializará cuando se cargue el producto

  /**
   * Inicializar los botones de quick add
   */
  function initQuickAdd() {
    const quickAddButtons = document.querySelectorAll('.product-card__quick-add-button:not([data-quick-add-initialized])');
    
    if (quickAddButtons.length === 0) {
      return; // No hay botones nuevos para inicializar
    }
    
    quickAddButtons.forEach(button => {
      // Verificar que el botón tenga los datos necesarios
      const productHandle = button.dataset.productHandle;
      if (!productHandle) {
        return;
      }
      
      button.setAttribute('data-quick-add-initialized', 'true');
      
      // Función para manejar el clic
      const handleQuickAddClick = function(e) {
        // Prevenir cualquier acción por defecto y propagación
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Prevenir que el enlace del producto se active
        const productCard = this.closest('.product-card');
        if (productCard) {
          const productLink = productCard.querySelector('.product-card__link');
          if (productLink) {
            productLink.style.pointerEvents = 'none';
            setTimeout(() => {
              productLink.style.pointerEvents = '';
            }, 100);
          }
        }
        
        const handle = this.dataset.productHandle || productHandle;
        const productId = this.dataset.productId;
        
        // Buscar los datos del producto desde el script JSON en el DOM
        let productData = null;
        
        if (productCard) {
          const dataScript = productCard.querySelector('script.product-card-data[data-product-handle="' + handle + '"]');
          if (dataScript) {
            try {
              productData = JSON.parse(dataScript.textContent);
            } catch (error) {
              console.error('Error al parsear datos del producto:', error);
              // Error al parsear datos del producto
            }
          }
        }
        
        if (productData) {
          // Usar datos de Liquid directamente
          openModalWithData(productData);
        } else if (handle) {
          // Fallback a fetch si no hay datos en el DOM
          openModal(handle, productId);
        } else {
          console.error('No se pudo encontrar el handle del producto');
        }
        
        return false;
      };
      
      // Agregar listener con captura para interceptar antes que otros listeners
      button.addEventListener('click', handleQuickAddClick, true);
      
      // Prevenir mousedown para evitar que el enlace capture el evento
      button.addEventListener('mousedown', function(e) {
        e.preventDefault();
        e.stopPropagation();
      }, true);
      
      // También prevenir el clic en el contenedor del quick-add
      const quickAddContainer = button.closest('.product-card__quick-add');
      if (quickAddContainer) {
        quickAddContainer.addEventListener('click', function(e) {
          // Si el clic es en el contenedor pero no en el botón, prevenir el enlace
          if (e.target === quickAddContainer) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
        
        quickAddContainer.addEventListener('mousedown', function(e) {
          e.preventDefault();
          e.stopPropagation();
        }, true);
      }
    });
    
  }
  window.initQuickAddButtons = initQuickAdd;

  /**
   * Abrir el modal y cargar datos del producto (fallback usando fetch)
   */
  function openModal(productHandle, productId) {
    if (!productHandle) {
      return;
    }
    
    // Prevenir múltiples aperturas
    if (modal.classList.contains('active')) {
      return;
    }

    // Guardar posición del scroll antes de bloquear
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Calcular el ancho del scrollbar para compensar el desplazamiento
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    
    // Aplicar bloqueo de scroll usando requestAnimationFrame para evitar "saltos"
    requestAnimationFrame(() => {
      // Bloquear scroll sin mover el contenido visualmente
    document.body.style.overflow = 'hidden';
      document.body.style.width = `calc(100% - ${scrollbarWidth}px)`;
      document.body.style.touchAction = 'none';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
    document.body.classList.add('modal-open');
    
    // También bloquear en html para mayor compatibilidad
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('modal-open');
    });

    // Mostrar modal
    // Ocultar mensajes previos al abrir
    const successMessage = modal.querySelector('.product-quick-add-modal__success-message');
    if (successMessage) {
      successMessage.style.display = 'none';
    }
    const errorMessage = modal.querySelector('.product-quick-add-modal__error-message');
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    
    modal.classList.add('active');
    modal.style.display = 'flex';
    
    // Mostrar loading
    showLoading();

    // Cargar producto
    fetchProductData(productHandle);
  }

  /**
   * Cerrar el modal
   */
  function closeModal(event) {
    if (event && event.type === 'click' && event.target !== modal.querySelector('.product-quick-add-modal__close')) {
      if (!event.target.closest('.product-quick-add-modal__close')) {
        return;
      }
    }
    
    // Ocultar mensajes de éxito y error al cerrar
    const successMessage = modal.querySelector('.product-quick-add-modal__success-message');
    if (successMessage) {
      successMessage.style.display = 'none';
    }
    const errorMessage = modal.querySelector('.product-quick-add-modal__error-message');
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    
    modal.classList.remove('active');
    
    // Restaurar scroll del body
    const savedScrollPosition = scrollPosition;
    
    // Restaurar estilos usando requestAnimationFrame para evitar "saltos"
    requestAnimationFrame(() => {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.touchAction = '';
    document.body.classList.remove('modal-open');
    
    // Restaurar scroll en html
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('modal-open');
    
    // Restaurar posición del scroll
      if (savedScrollPosition) {
        window.scrollTo(0, savedScrollPosition);
      }
    scrollPosition = 0;
    });
    
    // Remover clase scrollable al cerrar
    const infoContainer = modal.querySelector('.product-quick-add-modal__info-container');
    if (infoContainer) {
      infoContainer.classList.remove('scrollable');
      infoContainer.removeEventListener('scroll', checkScrollable);
    }
    
    setTimeout(() => {
      modal.style.display = 'none';
    }, 300);
    
    hideUnavailableMessage();
  }

  /**
   * Detectar si el contenedor tiene scroll y mostrar indicador visual
   */
  function checkScrollable() {
    const infoContainer = modal.querySelector('.product-quick-add-modal__info-container');
    if (!infoContainer) return;

    const hasScroll = infoContainer.scrollHeight > infoContainer.clientHeight;
    const isScrolledToBottom = infoContainer.scrollHeight - infoContainer.scrollTop <= infoContainer.clientHeight + 5;

    // Agregar/quitar clase para mostrar indicador cuando hay scroll disponible
    if (hasScroll && !isScrolledToBottom) {
      infoContainer.classList.add('scrollable');
    } else {
      infoContainer.classList.remove('scrollable');
    }
  }

  /**
   * Abrir modal con datos del producto (desde Liquid)
   */
  function openModalWithData(productData) {
    // Prevenir múltiples aperturas
    if (modal.classList.contains('active')) {
      return;
    }

    // Guardar posición del scroll antes de bloquear
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Bloquear scroll del body
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.touchAction = 'none';
    document.body.classList.add('modal-open');
    
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.position = 'fixed';
    document.documentElement.style.top = `-${scrollPosition}px`;
    document.documentElement.style.width = '100%';
    document.documentElement.classList.add('modal-open');

    // Mostrar modal
    modal.classList.add('active');
    modal.style.display = 'flex';
    
    // Procesar los datos del producto
    processProductData(productData);
  }

  /**
   * Procesar datos del producto y actualizar el modal
   */
  function processProductData(productData) {
    // Transformar los datos del producto al formato esperado
    const product = {
      ...productData,
      options: productData.options ? productData.options.map(opt => opt.name) : []
    };
    
    hideLoading();

    // Actualizar imagen, título y precio
    updateImage(product);
    updateTitle(product);
    updatePrice(product);

    // Verificar si tiene variantes
    if (!product.variants || product.variants.length === 0) {
      showUnavailableMessage();
      return;
    }

    hideUnavailableMessage();

    // Inicializar o re-inicializar el selector de variantes con los datos del producto
    const infoContainer = modal.querySelector('.product-quick-add-modal__info-container');
    const variantSelectorContainer = modal.querySelector('.product-variant-selector');

    if (variantSelectorContainer && typeof ProductVariantSelector !== 'undefined' && typeof renderQuickAddOptions !== 'undefined') {
      // Limpiar contenido anterior
      variantSelectorContainer.dataset.rendered = 'false';
      const variantButtons = variantSelectorContainer.querySelectorAll('[data-option-name]');
      variantButtons.forEach(btn => btn.remove());

      // Renderizar los botones de opciones primero
      renderQuickAddOptions(variantSelectorContainer, product);

      // Marcar como inicializado para evitar doble inicialización
      variantSelectorContainer.dataset.initialized = 'true';

      // Crear nueva instancia del selector con los datos del producto
      variantSelector = new ProductVariantSelector(
        variantSelectorContainer,
        product,
        {
          onVariantChange: function(variant) {
            // Actualizar disponibilidad de botones
            updateActionButtonsAvailability(variant);
            
            // Actualizar precio
            renderQuickAddPrice(variant);
            
            // Actualizar imagen si la variante tiene una
            if (variant.featured_image) {
              const imageElement = modal.querySelector('.product-quick-add-modal__image');
              if (imageElement && variant.featured_image) {
                imageElement.src = variant.featured_image;
                imageElement.style.opacity = '1';
              }
            }
          },
          onPriceUpdate: function(variant) {
            // Actualizar precio
            renderQuickAddPrice(variant);
          },
          onImageUpdate: function(imageUrl) {
            // Actualizar imagen principal del modal
            const imageElement = modal.querySelector('.product-quick-add-modal__image');
            if (imageElement && imageUrl) {
              // Asegurar protocolo completo
              if (imageUrl.startsWith('//')) {
                imageUrl = 'https:' + imageUrl;
              }
              imageElement.src = imageUrl;
              imageElement.style.opacity = '1';
            }
          }
        }
      );
      
      // Forzar actualización de UI después de la inicialización
      setTimeout(() => {
        if (variantSelector) {
          variantSelector.refreshUI();
        }
      }, 100);
    }

    // Configurar botones de acción
    setupActionButtons(product);

    // Verificar scroll después de cargar contenido
    setTimeout(() => {
      checkScrollable();
      // Agregar listener para scroll
      const infoContainer = modal.querySelector('.product-quick-add-modal__info-container');
      if (infoContainer) {
        // Remover listener anterior si existe
        infoContainer.removeEventListener('scroll', checkScrollable);
        // Agregar nuevo listener
        infoContainer.addEventListener('scroll', checkScrollable);
      }
    }, 200);
  }

  /**
   * Cargar datos del producto desde Shopify (fallback)
   */
  async function fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const productData = await response.json();
      
      // Transformar los datos del producto al formato esperado
      // La API de Shopify devuelve options como array de objetos {name, position, values}
      // pero el código espera un array de strings (nombres de opciones)
      const product = {
        ...productData,
        options: productData.options ? productData.options.map(opt => opt.name) : []
      };
      
      hideLoading();

      // Actualizar imagen, título y precio
      updateImage(product);
      updateTitle(product);
      updatePrice(product);

      // Verificar si tiene variantes
      if (!product.variants || product.variants.length === 0) {
        showUnavailableMessage();
        return;
      }

      hideUnavailableMessage();

      // Inicializar o re-inicializar el selector de variantes con los datos del producto
      const infoContainer = modal.querySelector('.product-quick-add-modal__info-container');
      const variantSelectorContainer = modal.querySelector('.product-variant-selector');
      
      if (variantSelectorContainer && typeof ProductVariantSelector !== 'undefined' && typeof renderQuickAddOptions !== 'undefined') {
        // Limpiar contenido anterior
        variantSelectorContainer.dataset.rendered = 'false';
        const variantButtons = variantSelectorContainer.querySelectorAll('[data-option-name]');
        variantButtons.forEach(btn => btn.remove());
        
        // Renderizar los botones de opciones primero
        renderQuickAddOptions(variantSelectorContainer, product);
        
        // Marcar como inicializado para evitar doble inicialización
        variantSelectorContainer.dataset.initialized = 'true';
        
        // Crear nueva instancia del selector con los datos del producto
        variantSelector = new ProductVariantSelector(
          variantSelectorContainer,
          product,
          {
            onVariantChange: function(variant) {
              // Actualizar disponibilidad de botones
              updateActionButtonsAvailability(variant);
              
              // Actualizar precio
              renderQuickAddPrice(variant);
              
              // Actualizar imagen si la variante tiene una
              if (variant.featured_image) {
                let imageUrl = variant.featured_image;
                if (typeof imageUrl === 'object' && imageUrl.src) {
                  imageUrl = imageUrl.src;
                }
                // Asegurar protocolo completo
                if (imageUrl && imageUrl.startsWith('//')) {
                  imageUrl = 'https:' + imageUrl;
                }
                
                const imageElement = modal.querySelector('.product-quick-add-modal__image');
                if (imageElement && imageUrl) {
                  imageElement.src = imageUrl;
                  imageElement.style.opacity = '1';
                }
              }
            },
            onPriceUpdate: function(variant) {
              // Actualizar precio
              renderQuickAddPrice(variant);
            },
            onImageUpdate: function(imageUrl) {
              // Actualizar imagen principal del modal
              const imageElement = modal.querySelector('.product-quick-add-modal__image');
              if (imageElement && imageUrl) {
                // Asegurar protocolo completo
                if (imageUrl.startsWith('//')) {
                  imageUrl = 'https:' + imageUrl;
                }
                imageElement.src = imageUrl;
                imageElement.style.opacity = '1';
              }
            }
          }
        );
        
        // Forzar actualización de UI después de la inicialización
        setTimeout(() => {
      if (variantSelector) {
            variantSelector.refreshUI();
          }
        }, 100);
      }

      // Configurar botones de acción
      setupActionButtons(product);

      // Verificar scroll después de cargar contenido
      setTimeout(() => {
        checkScrollable();
        // Agregar listener para scroll
        const infoContainer = modal.querySelector('.product-quick-add-modal__info-container');
        if (infoContainer) {
          // Remover listener anterior si existe
          infoContainer.removeEventListener('scroll', checkScrollable);
          // Agregar nuevo listener
          infoContainer.addEventListener('scroll', checkScrollable);
        }
      }, 200);
    } catch (error) {
      showError('Error al cargar el producto. Intenta de nuevo.');
    }
  }

  /**
   * Actualizar imagen del producto
   */
  function updateImage(product) {
    const imageElement = modal.querySelector('.product-quick-add-modal__image');
    if (!imageElement) return;
    
    let imageUrl = null;
    
    // Intentar obtener la imagen de featured_image primero
    if (product.featured_image) {
      imageUrl = product.featured_image;
    } else if (product.images && product.images.length > 0) {
      imageUrl = typeof product.images[0] === 'string' 
      ? product.images[0] 
      : (product.images[0].src || product.images[0]);
    }
    
    if (!imageUrl) return;
    
    // Asegurar que la URL tenga protocolo (las URLs de Shopify pueden empezar con //)
    if (imageUrl.startsWith('//')) {
      imageUrl = 'https:' + imageUrl;
    } else if (imageUrl.startsWith('/')) {
      imageUrl = window.location.origin + imageUrl;
    }
    
    imageElement.src = imageUrl;
    imageElement.alt = product.title || '';
  }

  /**
   * Actualizar título del producto
   */
  function updateTitle(product) {
    const titleElement = modal.querySelector('.product__title');
    if (titleElement) {
      titleElement.textContent = product.title || '';
    }
  }

  /**
   * Actualizar precio del producto
   */
  function updatePrice(product) {
    if (!product.variants || product.variants.length === 0) return;
    const firstVariant = product.variants[0];
    renderQuickAddPrice(firstVariant);
  }

  function formatMoneyValue(value) {
    if (window.Shopify?.formatMoney) {
      return Shopify.formatMoney(value);
    }
    if (window.moneyFormat) {
      const amount = value / 100;
      const format = window.moneyFormat;
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/);

      if (!match) {
        return `$${amount.toFixed(2)}`;
      }

      const token = match[1];
      const formatWithDelimiters = (number, precision = 2, thousands = '.', decimal = ',') => {
        if (isNaN(number) || number == null) return '0';
        const fixed = Number(number).toFixed(precision);
        const parts = fixed.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
      };

      let formatted = '';
      switch (token) {
        case 'amount':
          formatted = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals':
          formatted = formatWithDelimiters(amount, 0, '.', ',');
          break;
        case 'amount_with_comma_separator':
          formatted = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formatted = formatWithDelimiters(amount, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          formatted = formatWithDelimiters(amount, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          formatted = formatWithDelimiters(amount, 0, ' ', ',');
          break;
        case 'amount_with_apostrophe_separator':
          formatted = formatWithDelimiters(amount, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_apostrophe_separator':
          formatted = formatWithDelimiters(amount, 0, "'", '.');
          break;
        default:
          formatted = formatWithDelimiters(amount, 2, '.', ',');
      }

      return format.replace(match[0], formatted);
    }
    return `$${(value / 100).toFixed(2)}`;
  }

  function renderQuickAddPrice(variant) {
    const priceContainer = modal.querySelector('.product__price');
    if (!priceContainer || !variant) return;

    const priceHtml = [];
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHtml.push(
        `<span class="price-item price-item--sale">${formatMoneyValue(variant.price)}</span>`
      );
      priceHtml.push(
        `<span class="price-item price-item--regular price-item--compare">${formatMoneyValue(variant.compare_at_price)}</span>`
      );
    } else {
      priceHtml.push(
        `<span class="price-item price-item--regular">${formatMoneyValue(variant.price)}</span>`
      );
    }

    priceContainer.innerHTML = priceHtml.join('');
  }

  /**
   * Mostrar indicador de carga
   */
  function showLoading() {
    const modalContent = modal.querySelector('.product-quick-add-modal__content');
    if (!modalContent) return;

    let loadingIndicator = modalContent.querySelector('.loading-indicator');
    
    if (!loadingIndicator) {
      loadingIndicator = document.createElement('div');
      loadingIndicator.className = 'loading-indicator';
      loadingIndicator.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.9); display: flex; align-items: center; justify-content: center; z-index: 10003; font-size: 14px;';
      if (!modalContent.style.position) {
        modalContent.style.position = 'relative';
      }
      modalContent.appendChild(loadingIndicator);
    }
    
    loadingIndicator.textContent = 'Cargando...';
    loadingIndicator.style.display = 'flex';
  }

  /**
   * Ocultar indicador de carga
   */
  function hideLoading() {
    const loadingIndicator = modal.querySelector('.loading-indicator');
    if (loadingIndicator) {
      loadingIndicator.style.display = 'none';
    }
  }

  /**
   * Mostrar mensaje de no disponible
   */
  function showUnavailableMessage() {
    const unavailableMessage = modal.querySelector('.product-quick-add-modal__unavailable-message');
    const actionsContainer = modal.querySelector('.product-quick-add-modal__actions');
    const variantsContainer = modal.querySelector('.product-variant-selector__colors');
    const sizesSection = modal.querySelector('.product-variant-selector__sizes');
    const fitSection = modal.querySelector('.product-variant-selector__fit');
    const allDividers = modal.querySelectorAll('.product-quick-add-modal__divider');
    
    if (unavailableMessage) unavailableMessage.style.display = 'block';
    if (actionsContainer) actionsContainer.style.display = 'none';
    if (variantsContainer) variantsContainer.style.display = 'none';
    if (sizesSection) sizesSection.style.display = 'none';
    if (fitSection) fitSection.style.display = 'none';
    allDividers.forEach(divider => divider.style.display = 'none');
  }

  /**
   * Ocultar mensaje de no disponible
   */
  function hideUnavailableMessage() {
    const unavailableMessage = modal.querySelector('.product-quick-add-modal__unavailable-message');
    const actionsContainer = modal.querySelector('.product-quick-add-modal__actions');
    
    if (unavailableMessage) unavailableMessage.style.display = 'none';
    if (actionsContainer) actionsContainer.style.display = 'flex';
  }

  /**
   * Mostrar mensaje de error
   */
  function showError(message) {
    // Ocultar mensaje de éxito si está visible
    const successMessage = modal.querySelector('.product-quick-add-modal__success-message');
    if (successMessage) {
      successMessage.style.display = 'none';
    }
    
    let errorMessage = modal.querySelector('.product-quick-add-modal__error-message');
    
    if (!errorMessage) {
      errorMessage = document.createElement('div');
      errorMessage.className = 'product-quick-add-modal__error-message';
      errorMessage.style.cssText = 'padding: 12px 16px; background-color: #fee; border: 1px solid #fcc; color: #c33; border-radius: 4px; font-size: 14px; margin-bottom: 16px; display: none;';
      
      const actionsContainer = modal.querySelector('.product-quick-add-modal__actions');
      if (actionsContainer && actionsContainer.parentElement) {
        actionsContainer.parentElement.insertBefore(errorMessage, actionsContainer);
      }
    }
    
    errorMessage.textContent = message;
    errorMessage.style.display = 'block';
    
    setTimeout(() => {
      if (errorMessage) {
        errorMessage.style.display = 'none';
      }
    }, 5000);
  }

  /**
   * Mostrar mensaje de éxito (minimalista)
   */
  function showSuccess(message) {
    // Ocultar mensaje de error si está visible
    const errorMessage = modal.querySelector('.product-quick-add-modal__error-message');
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    
    const successMessage = modal.querySelector('.product-quick-add-modal__success-message');
    if (!successMessage) return;
    
    // Actualizar mensaje si se proporciona uno personalizado
    const messageText = successMessage.querySelector('span');
    if (messageText && message) {
      // Si el mensaje personalizado no incluye el check, agregarlo
      if (!message.includes('✓') && !message.includes('check')) {
        messageText.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0;"><path d="M11.667 3.5L5.25 9.917L2.333 7" stroke="#00A859" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> ${message}`;
      } else {
        messageText.textContent = message;
      }
    }
    
    // Mostrar con animación fade-in
    successMessage.style.opacity = '0';
    successMessage.style.display = 'block';
    requestAnimationFrame(() => {
      successMessage.style.transition = 'opacity 0.3s ease';
      successMessage.style.opacity = '1';
    });
    
    // Ocultar después de 2 segundos con fade-out
    setTimeout(() => {
      if (successMessage) {
        successMessage.style.transition = 'opacity 0.3s ease';
        successMessage.style.opacity = '0';
        setTimeout(() => {
          if (successMessage) {
            successMessage.style.display = 'none';
          }
        }, 300);
      }
    }, 2000);
  }

  /**
   * Actualizar disponibilidad de los botones de acción
   */
  function updateActionButtonsAvailability(variant) {
    const addToCartButton = modal.querySelector('.product-quick-add-modal__button--add-to-cart');
    const buyNowButton = modal.querySelector('.product-quick-add-modal__button--buy-now');
    
    if (!variant) {
      disableButtons('NO DISPONIBLE');
      return;
    }
    
    /**
     * Shopify source of truth:
     * - available === true → se puede vender
     * - available === false → agotado
     */
    const isAvailable = variant.available === true;
    
      if (isAvailable) {
      enableButtons();
      } else {
      disableButtons('AGOTADO');
    }
    
    function enableButtons() {
      if (addToCartButton) {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'AÑADIR AL CARRO';
      }
    if (buyNowButton) {
        buyNowButton.disabled = false;
        buyNowButton.textContent = 'COMPRAR AHORA';
        buyNowButton.style.removeProperty('display');
        buyNowButton.style.removeProperty('important');
      }
    }
  
    function disableButtons(label) {
      if (addToCartButton) {
        addToCartButton.disabled = true;
        addToCartButton.textContent = label;
      }
      if (buyNowButton) {
        buyNowButton.disabled = true;
        buyNowButton.textContent = label;
        buyNowButton.style.setProperty('display', 'none', 'important');
      }
    }
  }
  

  /**
   * Configurar botones de acción
   */
  function setupActionButtons(product) {
    const addToCartButton = modal.querySelector('.product-quick-add-modal__button--add-to-cart');
    const buyNowButton = modal.querySelector('.product-quick-add-modal__button--buy-now');

    // Remover listeners anteriores
    const newAddToCart = addToCartButton.cloneNode(true);
    const newBuyNow = buyNowButton.cloneNode(true);
    addToCartButton.parentNode.replaceChild(newAddToCart, addToCartButton);
    buyNowButton.parentNode.replaceChild(newBuyNow, buyNowButton);

    newAddToCart.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Obtener variantId del selector o del producto
      let variantId = null;
      
      if (variantSelector) {
        // Actualizar currentVariant antes de obtener el ID
        variantSelector.refreshUI();
        variantId = variantSelector.getSelectedVariantId();
      }
      
      if (!variantId) {
        const firstAvailable = product.variants.find(v => v.available);
        if (firstAvailable) {
          variantId = firstAvailable.id;
        } else if (product.variants.length > 0) {
          variantId = product.variants[0].id;
        }
      }
      
      if (!variantId) {
        showError('Por favor selecciona una variante');
        return;
      }
      
        await addToCart(variantId);
    });

    newBuyNow.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Obtener variantId del selector o del producto
      let variantId = null;
      
      if (variantSelector) {
        // Actualizar currentVariant antes de obtener el ID
        variantSelector.refreshUI();
        variantId = variantSelector.getSelectedVariantId();
      }
      
      if (!variantId) {
        const firstAvailable = product.variants.find(v => v.available);
        if (firstAvailable) {
          variantId = firstAvailable.id;
        } else if (product.variants.length > 0) {
          variantId = product.variants[0].id;
        }
      }
      
      if (!variantId) {
        showError('Por favor selecciona una variante');
        return;
      }
      
        await buyNow(variantId);
    });
  }

  /**
   * Añadir al carrito
   */
  async function updateHeaderCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCountElements = document.querySelectorAll('.cart-count, .header__action-badge--text, [data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count || 0;
      });
    } catch (error) {
      // noop
    }
  }

  async function addToCart(variantId) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw { status: response.status, data: errorData };
      }

      const data = await response.json();
      
      if (data.status) {
        showError(data.message || 'Error al agregar al carrito');
        return;
      }
      
      // Mostrar mensaje de éxito
      showSuccess('¡Producto agregado al carrito exitosamente!');
      
      // Actualizar badge del carrito
      await updateHeaderCartCount();
      
      // Actualizar drawer del carrito
      await updateCartDrawer();
      
      // Cerrar modal y abrir drawer después de mostrar el mensaje de éxito
      setTimeout(() => {
        closeModal();
        setTimeout(() => {
          if (window.openCartDrawer) {
            window.openCartDrawer();
          }
        }, 100);
      }, 1500); // Esperar 1.5 segundos para que el usuario vea el mensaje de éxito
      
      // Disparar evento
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    } catch (error) {
      if (error.status === 422 || (error.data && error.data.status === 422)) {
        const errorMessage = error.data?.message || error.data?.description || 'Este producto está agotado';
        showError(errorMessage);
      } else {
        showError('Error al agregar al carrito. Intenta de nuevo.');
      }
    }
  }

  /**
   * Comprar ahora
   */
  async function buyNow(variantId) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw { status: response.status, data: errorData };
      }

      const data = await response.json();
      
      if (data.status) {
        showError(data.message || 'Error al agregar al carrito');
        return;
      }
      
      // Redirigir al checkout
      window.location.href = '/checkout';
    } catch (error) {
      if (error.status === 422 || (error.data && error.data.status === 422)) {
        const errorMessage = error.data?.message || error.data?.description || 'Este producto está agotado';
        showError(errorMessage);
      } else {
        showError('Error al agregar al carrito. Intenta de nuevo.');
      }
    }
  }

  /**
   * Actualizar drawer del carrito
   */
  async function updateCartDrawer() {
    return new Promise((resolve) => {
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (!cartDrawer) {
        resolve();
        return;
      }
    
      const url = `${window.location.pathname}?sections=cart-drawer`;
    
      fetch(url)
        .then(response => response.text())
        .then(html => {
          try {
            const parsedState = JSON.parse(html);
            
            if (parsedState.sections && parsedState.sections['cart-drawer']) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(parsedState.sections['cart-drawer'], 'text/html');
              const newDrawer = doc.getElementById('Cart-Drawer');
              
              if (newDrawer) {
                cartDrawer.innerHTML = newDrawer.innerHTML;
              }
            }
            
            resolve();
          } catch (e) {
            resolve();
          }
        })
        .catch(error => {
          resolve();
        });
    });
  }

  // Configurar listeners del modal
  const closeButton = modal.querySelector('.product-quick-add-modal__close');
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  // Prevenir scroll en el overlay del modal
  modal.addEventListener('wheel', function(e) {
    if (!e.target.closest('.product-quick-add-modal__content')) {
      e.preventDefault();
    }
  }, { passive: false });

  modal.addEventListener('touchmove', function(e) {
    if (!e.target.closest('.product-quick-add-modal__content')) {
      e.preventDefault();
    }
  }, { passive: false });

  // Cerrar con ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal(e);
    }
  }, true);

  // Inicializar botones de quick add
  initQuickAdd();
  
  // Re-inicializar cuando se carguen productos dinámicamente
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          // Verificar si el nodo es un product-card o contiene uno
          if (node.nodeType === 1) { // Solo elementos
            if (node.classList && (
              node.classList.contains('product-card') || 
              node.querySelector('.product-card') ||
              node.querySelector('.product-card__quick-add-button')
            )) {
              shouldReinit = true;
        }
      }
    });
      }
  });
  
    if (shouldReinit) {
      setTimeout(function() {
        initQuickAdd();
      }, 50);
    }
  });
  
  // Observar todos los grids de productos posibles
  const productGrids = document.querySelectorAll(
    '.filtered-products-grid, ' +
    '.collection__grid, ' +
    '.related-products__grid, ' +
    '[class*="collection__grid-"], ' +
    '.featured-collection__grid, ' +
    '[class*="featured-collection__grid-"], ' +
    '.product-grid, ' +
    '[class*="product-grid"], ' +
    '.products-grid, ' +
    '[class*="products-grid"]'
  );
  
  productGrids.forEach(grid => {
    if (grid) {
      observer.observe(grid, { childList: true, subtree: true });
    }
  });
  
  // Observar el body para capturar cualquier grid o producto que se agregue dinámicamente
  if (document.body && document.body instanceof Node) {
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: false,
    attributeOldValue: false
  });
  }
  
  // Re-inicializar después de un pequeño delay para asegurar que todos los elementos estén en el DOM
  setTimeout(function() {
    initQuickAdd();
  }, 100);
  
  // Re-inicializar cuando se actualice el carrito (por si se recargan productos)
  document.addEventListener('cart:updated', function() {
    setTimeout(function() {
      initQuickAdd();
    }, 100);
  });
  
  // Re-inicializar cuando se cargue contenido dinámicamente (AJAX, etc.)
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      initQuickAdd();
    }, 200);
  });
  
  // Re-inicializar periódicamente para capturar productos que se agreguen después
  // Esto es un fallback para casos donde el MutationObserver no detecte cambios
  setInterval(function() {
    const uninitializedButtons = document.querySelectorAll('.product-card__quick-add-button:not([data-quick-add-initialized])');
    if (uninitializedButtons.length > 0) {
      initQuickAdd();
    }
  }, 1000);
});
